import React from 'react';

interface Props {
  width?: string;
  height?: string;
  viewBox?: [string, string];
  className?: string;
  onClick?: VoidFunction;
}

const LetterGenerator = (props: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width || '24'}
      height={props.height || '24'}
      onClick={props.onClick}
      viewBox={`0 0 ${(props.viewBox?.[0] ?? props.width) || '24'} ${
        (props.viewBox?.[1] ?? props.height) || '24'
      }`}
    >
      <path id="Path_34604" d="M0,0H24V24H0Z" fill="none" />
      <path
        id="Path_34605"
        d="M20,2a2,2,0,0,1,2,1.99V20.01A1.992,1.992,0,0,1,20,22H4V18H2V16H4V13H2V11H4V8H2V6H4V2ZM8,4H6V20H8ZM20,4H10V20H20Z"
        fill="#575757"
      />
    </svg>
  );
};

export default LetterGenerator;
